// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"351":"5fd20870","496":"d51f75f5"}[chunkId] + ".chunk.js";
};